import { SiteLayout } from '../../components/SiteLayout';
import { Icon } from '../../components/Icon';
import { ReleaseButton, ReleaseMeta } from '../../components/ReleaseButton';
import { usePageMeta } from '../../lib/meta';
import { useRelease } from '../../lib/releases';

const STRIP = [
  { icon: 'quality', title: 'Source quality', text: 'Never upscaled' },
  { icon: 'collection', title: 'Collections', text: 'Organize what you save' },
  { icon: 'compass', title: 'AI discovery', text: 'Find similar videos' },
  { icon: 'cc', title: 'Subtitles & transcripts', text: 'Translate with AI' },
];

const CARDS = [
  { icon: 'hd', title: 'High Quality', text: 'Real source resolutions, labeled honestly.', href: '/download' },
  { icon: 'search', title: 'Smart Search', text: 'Similar videos ranked from real metadata.', href: '/discover' },
  { icon: 'text', title: 'AI Transcripts', text: 'Speech to text with timestamps and summaries.', href: '/app/ai' },
  { icon: 'library', title: 'Organize Library', text: 'Collections, favorites and watch later.', href: '/library' },
];

export function Features() {
  usePageMeta('Features', 'Discover. Save. Create. Ayonix Studio finds videos with AI-assisted discovery, saves media you’re allowed to download at its real quality, and turns audio into transcripts.');
  const release = useRelease();
  return (
    <SiteLayout>
      <div class="container">
        <section class="mk-hero" aria-labelledby="mk-h">
          <div class="mk-copy">
            <h1 id="mk-h" class="display grad stacked"><span>Discover.</span> <span>Save.</span> <span>Create.</span></h1>
            <p class="lede">Discover videos with AI, save media you’re allowed to download at its real quality, and turn audio into searchable transcripts.</p>
            <div class="row cta-row">
              <ReleaseButton state={release} platform="mac" />
              <a class="btn outline lg" href="/">Try Web App <Icon name="arrowRight" size={18} /></a>
            </div>
            <ReleaseMeta state={release} platform="mac" />
          </div>
          <figure class="laptop" aria-label="The Ayonix Studio web app">
            <div class="laptop-screen"><img src="/img/web-app.webp" width="1440" height="900" alt="The Ayonix Studio web downloader showing the real formats published for a Wikimedia Commons film." /></div>
            <div class="laptop-base" />
          </figure>
        </section>

        <ul class="feature-strip" aria-label="Highlights">
          {STRIP.map((s) => (
            <li key={s.title}><span class="strip-icon"><Icon name={s.icon} size={22} /></span><strong>{s.title}</strong><span class="muted small">{s.text}</span></li>
          ))}
        </ul>

        <section class="section center" aria-labelledby="more-h">
          <h2 id="more-h" class="section-title">More Than a Downloader</h2>
          <p class="muted">Discover, organize and understand videos with AI.</p>
          <div class="more-cards">
            {CARDS.map((c) => (
              <a key={c.title} class="more-card" href={c.href}>
                <span class="tile-icon blue"><Icon name={c.icon} size={22} /></span>
                <strong>{c.title}</strong>
                <span>{c.text}</span>
              </a>
            ))}
          </div>
        </section>

        <figure class="scenic-band">
          <img src="/img/band-sunset.webp" srcSet="/img/band-sunset-960.webp 960w, /img/band-sunset.webp 1920w" sizes="(max-width: 900px) 100vw, 1240px" alt="A hiker sits on a rock above a still mountain lake at sunset." loading="lazy" />
          <figcaption>
            <span class="script">Your favorite videos,<br />always with you</span>
          </figcaption>
          <a class="photo-credit" href="/credits">Photo: Dreamy Pixel · CC BY 4.0</a>
        </figure>
      </div>
    </SiteLayout>
  );
}
